import { Anchor, Badge, Box, CloseButton, Group, Text } from "@mantine/core";
import React, { useState } from "react";

const TaskBanner: React.FC<{ overdue: number; userName: string }> = ({ overdue, userName }) => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  const hour = new Date().getHours();
  const greet =
    hour > 0 && hour <= 12
      ? "God morgen"
      : hour > 12 && hour <= 18
      ? "God ettermiddag"
      : hour > 18
      ? "God kveld"
      : "Hei";

  return (
    <Box
      pos="relative"
      bg="yellow.0" // mjukt gult
      style={{
        borderTop: "1px solid var(--mantine-color-yellow-4)",
        borderBottom: "1px solid var(--mantine-color-yellow-4)",
      }}
      px="md"
      py={6} // låg höjd
    >
      <Group justify="center" align="center" gap={6} wrap="nowrap">
        <Anchor href="#/tasks" underline="never" c="dark.6">
          <Text ta="center" size="sm">
            {greet}, {userName}! Du har{" "}
            <Badge
              color="red"
              variant="light"
              radius="sm"
              size="sm"
              styles={{ root: { paddingInline: 6, border: "1px solid #fff" } }}
            >
              <b>{overdue}</b>
            </Badge>{" "}
            {overdue === 1 ? "oppgave" : "oppgaver"} som har passert tidsfrist.
          </Text>
        </Anchor>
      </Group>

      <CloseButton aria-label="Lukk" onClick={() => setVisible(false)} pos="absolute" right={8} top={6} />
    </Box>
  );
};

export default TaskBanner;
